export const ACTION = {
  SHOW: 'SHOW_SIDE_MENU',
  HIDE: 'HIDE_SIDE_MENU',
};

export const showSideMenu = () => ({
  type: ACTION.SHOW,
});

export const hideSideMenu = () => ({
  type: ACTION.HIDE,
});



// WEBPACK FOOTER //
// ./src/redux/app/app_actions.js